import { HTMLAttributes } from 'react'

export const Paper = ({ className = '', ...props }: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={`p-4 flex flex-col gap-4 border-[1px] border-sec10 rounded-[8px] bg-b0 backdrop-blue-[20px] shadow-[0_0.5px0_0_#ECEFF0,0_6px_14px_0_rgba(0,0,0,0.05)] ${className}`}
    {...props}
  />
)
